export default "__VITE_ASSET__DFi0N8vm__"